import axios from 'axios';
const hostapi = process.env.VUE_APP_API_URL+'/';

export const fetchGetOrderReceiptEvrt = async ({ receipt_code, store_code }) => {
  const ApiUrl = hostapi + 'RequestOrder/GetOrderRequestEvrt';
  
  const body = {
    receipt_code,
    store_code
  };
  
  try {
    const response = await axios.post(ApiUrl, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'fetchGetOrderReceiptEvrt Error Evrt';
  }
};


export const fetchGetOrderReceiptItem = async ({ receipt_code, store_code }) => {
  const ApiUrl = hostapi + 'RequestOrder/GetReceiptItemRequest';
  
  const body = {
    receipt_code,
    store_code
  };
  
  try {
    const response = await axios.post(ApiUrl, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'fetchGetOrderReceipt Error';
  }
};


export const CreateEvrtInvoiceRequest = async (payload) => {
  const ApiUrl = hostapi + 'EvrtInvoiceRequest/CreateEvrtInvoice';

  try {
    const response = await axios.post(ApiUrl, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'CreateEvrtInvoiceRequest Error';
  }
};

export const fetchGetCountry = async ( code ) => {
  const ApiUrl = hostapi + 'MasterData/GetCountry';
  
  const body = {
    code,
  };
  
  try {
    const response = await axios.post(ApiUrl, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'fetchGetCountry Error';
  }
};


export const fetchCountryList = async (query) => {
  const ApiUrl = hostapi + 'MasterData/GetCountry';
  const body = { q: query };

  try {
    const response = await axios.post(ApiUrl, body, {
      headers: { 'Content-Type': 'application/json' }
    });
    console.log('fetchCountryList response:', response.data);  
    return response.data;
  } catch (error) {
    console.error('fetchCountryList error:', error);
    return [];
  }
};


export const fetchNationalityList = async (query) => {
  const ApiUrl = hostapi + 'MasterData/GetNationality';
  const body = { q: query };

  try {
    const response = await axios.post(ApiUrl, body, {
      headers: { 'Content-Type': 'application/json' }
    });
    console.log('fetchCountryList response:', response.data);  
    return response.data;
  } catch (error) {
    console.error('fetchCountryList error:', error);
    return [];
  }
};